import styled from 'styled-components';

import { LatestImage, NowCommonProps, ObsId, ScamId } from 'libs/types';

import Skycam from './Skycam';
import Scam from './Scam';

const SCAM_ID_LIST = ['1', '2', '3', '4'] as ScamId[];

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(245px, auto));
  margin-top: 30px;
  gap: 30px;
`;

const CamLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const ScamWrapper = styled.div`
  padding: 0 30px;
`;

const ScamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`;

interface CamGridProps extends NowCommonProps {
  latestSkycam?: Record<ObsId, LatestImage>;
  latestScam?: Record<ObsId, Record<ScamId, LatestImage>>;
}

const CamGrid = ({ obsInfo, obsOrderList, latestScam, latestSkycam }: CamGridProps) => {
  return (
    <Container>
      {obsOrderList.map((obsId) => {
        const obsName = obsInfo?.[obsId].obs_name;
        const latestTime = latestSkycam?.[obsId].latest_time;
        const latestDateTime = latestTime ? latestTime.split(' ') : ['', ''];
        const skycamUrl = latestSkycam?.[obsId].url;
        const skycamPath = skycamUrl
          ? `${process.env.REACT_APP_API_URL}${skycamUrl}`
          : undefined;
        const skycamUpdatedAt = latestSkycam?.[obsId].updated_at;

        return (
          <CamLayout key={`camlayout_${obsId}`}>
            <Skycam
              obsId={obsId}
              obsName={obsName ?? ''}
              latestDate={latestDateTime[0].replaceAll('-', '.')}
              latestTime={latestDateTime[1]}
              skycamPath={skycamPath}
              updatedAt={skycamUpdatedAt}
            />
            <ScamWrapper>
              <ScamGrid>
                {SCAM_ID_LIST.map((scamId) => {
                  const scam = latestScam?.[obsId]?.[scamId];
                  const scamUrl = scam?.url;
                  const scamPath = scamUrl
                    ? `${process.env.REACT_APP_API_URL}${scamUrl.replace('#', '%23')}`
                    : undefined;
                  const scamUpdatedAt = scam?.updated_at;
                  return <Scam key={`scam_${scamId}`} scamPath={scamPath} updatedAt={scamUpdatedAt} />;
                })}
              </ScamGrid>
            </ScamWrapper>
          </CamLayout>
        );
      })}
    </Container>
  );
};

export default CamGrid;
